import {Injectable} from '@angular/core';
import {ApiResponse} from '../Api/base-api.service';
import {FiltersModelService} from '../Models/Core/filters-model.service';
import {LocalsApiService} from '../Api/Core/locals-api.service';
import {LocationsApiService} from '../Api/Core/locations-api.service';
import {RolesApiService} from '../Api/Core/roles-api.service';
import {NotificationsApiService} from '../Api/Notifications/notifications-api.service';
import {DevicesApiService} from '../Api/Core/devices-api.service';
import {UsersApiService} from '../Api/Users/users-api.service';
import {DepartmentsApiService} from '../Api/Core/departments-api.service';
import {HolidaysApiService} from '../Api/Rrhh/Holidays/holidays-api.service';
import {ServicesApiService} from '../Api/Core/services-api.service';
import {AllergensApiService} from '../Api/Core/allergens-api.service';
import {UnitsProductApiService} from '../Api/Purchases/Products/units-product-api.service';
import {VatApiService} from '../Api/Core/vat-api.service';
import {ProductsFamiliesApiService} from '../Api/Purchases/Products/products-families-api.service';
import {ProductsLabelsApiService} from '../Api/Purchases/Products/products-labels-api.service';
import {ShiftsApiService} from '../Api/Core/shifts-api.service';
import {FamiliesExpensesApiService} from '../Api/Finances/Expenses/families-expenses-api.service';
import {ContractsApiService} from '../Api/Rrhh/Contracts/contracts-api.service';
import {CategoriesApiService} from '../Api/Core/categories-api.service';
import {PeriodsApiService} from '../Api/Core/periods-api.service';
import {WastagesApiService} from '../Api/Warehouse/Wastages/wastages-api.service';
import {RequestsApiService} from '../Api/Rrhh/Requests/requests-api.service';
import {DashboardsApiService} from '../Api/Dashboards/dashboards-api.service';
import {FranchiseesApiService} from '../Api/Core/franchisees-api.service';
import {CommunicationApiService} from '../Api/Communication/communication-api.service';
import {AssistantApiService} from '../Api/Assistant/assistant-api.service';
import {FamiliesEventsApiService} from '../Api/Events/families-events-api.service';
import {PurchasesReportsApiService} from '../Api/Reports/Purchases/purchases-reports-api.service';
import {ClockInReportApiService} from '../Api/Reports/Rrhh/clock-in-report-api.service';
import {TasksReportsApiService} from '../Api/Reports/Tasks/tasks-reports-api.service';
import {EventsApiService} from '../Api/Events/events-api.service';
import {CashClosingApiService} from '../Api/Finances/Cash-closing/cash-closing-api.service';
import {PaymentsApiService} from '../Api/Finances/Payments/payments-api.service';
import {EbitdaApiService} from '../Api/Finances/Ebitda/ebitda-api.service';
import {ExpensesApiService} from '../Api/Finances/Expenses/expenses-api.service';
import {DeliveryNotesApiService} from '../Api/Purchases/Delivery-notes/delivery-notes-api.service';
import {OrdersApiService} from '../Api/Purchases/Orders/orders-api.service';
import {ProductsApiService} from '../Api/Purchases/Products/products-api.service';
import {ProvidersApiService} from '../Api/Purchases/Providers/providers-api.service';
import {ClockInApiService} from '../Api/Rrhh/Clock-in/clock-in-api.service';
import {FoldersApiService} from '../Api/Rrhh/Folders/folders-api.service';
import {PublicHolidaysApiService} from '../Api/Rrhh/Public-holidays/public-holidays-api.service';
import {SchedulesApiService} from '../Api/Rrhh/Schedules/schedules-api.service';
import {MachinesCheckpointApiService} from '../Api/Tasks/Appccs/machines-checkpoint-api.service';
import {ProductsCheckpointApiService} from '../Api/Tasks/Appccs/products-checkpoint-api.service';
import {ProvidersCheckpointApiService} from '../Api/Tasks/Appccs/providers-checkpoint-api.service';
import {SchedulesAppccsApiService} from '../Api/Tasks/Appccs/schedules-appccs-api.service';
import {ModelsApiService} from '../Api/Tasks/Checklists/models-api.service';
import {SchedulesChecklistApiService} from '../Api/Tasks/Checklists/schedules-checklist-api.service';
import {ImageReviewerApiService} from '../Api/Tasks/General/image-reviewer-api.service';
import {TasksApiService} from '../Api/Tasks/General/tasks-api.service';
import {InventoriesApiService} from '../Api/Warehouse/Inventories/inventories-api.service';
import {InventoryStockService} from '../Models/Warehouse/Inventories/inventory-stock.service';
import {OperationsApiService} from '../Api/Warehouse/Operations/operations-api.service';
import {RevisionsApiService} from '../Api/Warehouse/Revisions/revisions-api.service';
import {ReloadsApiService} from '../Api/Warehouse/Reloads/reloads-api.service';
import {StocksApiService} from '../Api/Warehouse/Stocks/stocks-api.service';
import {TransfersApiService} from '../Api/Warehouse/Transfers/transfers-api.service';
import {ElaborationsApiService} from '../Api/YuChef/Elaborations/elaborations-api.service';
import {LabeledApiService} from '../Api/YuChef/Labeled/labeled-api.service';
import {MiseEnPlaceApiService} from '../Api/YuChef/Mise-en-place/mise-en-place-api.service';
import {RecipesApiService} from '../Api/YuChef/Recipes/recipes-api.service';
import {RecipesCostingApiService} from '../Api/YuChef/Recipes-costing/recipes-costing-api.service';
import {DocumentsReviewApiService} from '../Api/Documents-review/documents-review-api.service';

@Injectable({
  providedIn: 'root'
})
export class DataManagerService {

  constructor(
    private readonly filtersService: FiltersModelService,
    private readonly localsService: LocalsApiService,
    private readonly locationsService: LocationsApiService,
    private readonly rolesService: RolesApiService,
    private readonly devicesService: DevicesApiService,
    private readonly usersService: UsersApiService,
    private readonly departmentsService: DepartmentsApiService,
    private readonly servicesService: ServicesApiService,
    private readonly allergensService: AllergensApiService,
    private readonly unitsProductService: UnitsProductApiService,
    private readonly vatService: VatApiService,
    private readonly shiftsService: ShiftsApiService,
    private readonly productsFamiliesService: ProductsFamiliesApiService,
    private readonly productsLabelsService: ProductsLabelsApiService,
    private readonly notificationsService: NotificationsApiService,
    private readonly holidaysService: HolidaysApiService,
    private readonly familiesExpensesService: FamiliesExpensesApiService,
    private readonly contractsService: ContractsApiService,
    private readonly categoriesService: CategoriesApiService,
    private readonly periodsService: PeriodsApiService,
    private readonly wastageService: WastagesApiService,
    private readonly requestsService: RequestsApiService,
    private readonly dashboardsService: DashboardsApiService,
    private readonly franchiseesService: FranchiseesApiService,
    private readonly communicationsService: CommunicationApiService,
    private readonly assistantService: AssistantApiService,
    private readonly familiesEventsService: FamiliesEventsApiService,
    private readonly purchasesReportsService: PurchasesReportsApiService,
    private readonly clockInReportService: ClockInReportApiService,
    private readonly tasksReportsService: TasksReportsApiService,
    private readonly eventsService: EventsApiService,
    private readonly cashClosingService: CashClosingApiService,
    private readonly paymentsService: PaymentsApiService,
    private readonly ebitdaService: EbitdaApiService,
    private readonly expensesService: ExpensesApiService,
    private readonly deliveryNotesService: DeliveryNotesApiService,
    private readonly ordersService: OrdersApiService,
    private readonly productsService: ProductsApiService,
    private readonly providersService: ProvidersApiService,
    private readonly clockInService: ClockInApiService,
    private readonly foldersService: FoldersApiService,
    private readonly publicHolidaysService: PublicHolidaysApiService,
    private readonly schedulesService: SchedulesApiService,
    private readonly machinesCheckpointService: MachinesCheckpointApiService,
    private readonly productsCheckpointService: ProductsCheckpointApiService,
    private readonly providersCheckpointService: ProvidersCheckpointApiService,
    private readonly schedulesAppccsService: SchedulesAppccsApiService,
    private readonly schedulesChecklistService: SchedulesChecklistApiService,
    private readonly modelsService: ModelsApiService,
    private readonly imageReviewerService: ImageReviewerApiService,
    private readonly tasksService: TasksApiService,
    private readonly inventoriesService: InventoriesApiService,
    private readonly inventoryStockService: InventoryStockService,
    private readonly revisionsService: RevisionsApiService,
    private readonly reloadsService: ReloadsApiService,
    private readonly operationsService: OperationsApiService,
    private readonly stocksService: StocksApiService,
    private readonly transfersService: TransfersApiService,
    private readonly elaborationsService: ElaborationsApiService,
    private readonly labeledService: LabeledApiService,
    private readonly miseEnPlaceService: MiseEnPlaceApiService,
    private readonly recipesService: RecipesApiService,
    private readonly recipesCostingService: RecipesCostingApiService,
    private readonly documentsReviewService: DocumentsReviewApiService,
  ) {
  }

  /**
   * Obtener todos los datos del servidor
   *
   */
  getData() {
    return new Promise((resolve, reject) => {
      const promiseLocals: Promise<ApiResponse> = this.localsService.getLocals();
      const promiseLocalFamilies: Promise<ApiResponse> = this.localsService.getLocalFamilies();
      const promiseLocations: Promise<ApiResponse> = this.locationsService.getLocations();
      const promiseRoles: Promise<ApiResponse> = this.rolesService.getRoles();
      const promiseDevices: Promise<ApiResponse> = this.devicesService.getDevices();
      const promiseUsers: Promise<ApiResponse> = this.usersService.getUsers();
      const promiseDepartments: Promise<ApiResponse> = this.departmentsService.getDepartments();
      const promiseServices: Promise<ApiResponse> = this.servicesService.getServices();
      const promiseAllergens: Promise<ApiResponse> = this.allergensService.getAllergens();
      const promiseUnitsProduct: Promise<ApiResponse> = this.unitsProductService.getUnitsProduct();
      const promiseVat: Promise<ApiResponse> = this.vatService.getVat();
      const promiseProductsFamilies: Promise<ApiResponse> = this.productsFamiliesService.getProductsFamilies();
      const promiseProductsLabels: Promise<ApiResponse> = this.productsLabelsService.getProductsLabels();
      const promiseNotificationsGroups: Promise<ApiResponse> = this.notificationsService.getNotificationsGroups();
      const promiseHolidaysTypes: Promise<ApiResponse> = this.holidaysService.getHolidaysTypes();
      const promiseShifts: Promise<ApiResponse> = this.shiftsService.getShifts();
      const promiseFamiliesExpenses: Promise<ApiResponse> = this.familiesExpensesService.getFamiliesExpenses();
      const promiseContractsTypes: Promise<ApiResponse> = this.contractsService.getContractsTypes();
      const promiseEndReasons: Promise<ApiResponse> = this.contractsService.getEndReasons();
      const promiseCategories: Promise<ApiResponse> = this.categoriesService.getCategories();
      const promisePeriods: Promise<ApiResponse> = this.periodsService.getPeriods();
      const promiseWastageTypes: Promise<ApiResponse> = this.wastageService.getWastageTypes();
      const promiseRequestsTypes: Promise<ApiResponse> = this.requestsService.getRequestsTypes();
      const promiseDashboards: Promise<ApiResponse> = this.dashboardsService.getDashboards();
      const promiseFranchisees: Promise<ApiResponse> = this.franchiseesService.getFranchisees();
      const promiseBreakdownsTypes: Promise<ApiResponse> = this.communicationsService.getBreakdownsTypes();
      const promiseBreakdownsPriorities: Promise<ApiResponse> = this.communicationsService.getBreakdownsPriorities();
      const promiseFamiliesEvents: Promise<ApiResponse> = this.familiesEventsService.getFamiliesEvents();
      const promisePurchaseFormats: Promise<ApiResponse> = this.providersService.getPurchaseFormats();

      const promises: Promise<ApiResponse>[] = [
        promiseLocals,
        promiseLocalFamilies,
        promiseLocations,
        promiseRoles,
        promiseDevices,
        promiseUsers,
        promiseDepartments,
        promiseServices,
        promiseAllergens,
        promiseUnitsProduct,
        promiseVat,
        promiseProductsFamilies,
        promiseProductsLabels,
        promiseNotificationsGroups,
        promiseHolidaysTypes,
        promiseShifts,
        promiseFamiliesExpenses,
        promiseContractsTypes,
        promiseEndReasons,
        promiseCategories,
        promisePeriods,
        promiseWastageTypes,
        promiseRequestsTypes,
        promiseDashboards,
        promiseFranchisees,
        promiseBreakdownsTypes,
        promiseBreakdownsPriorities,
        promiseFamiliesEvents,
        promisePurchaseFormats,
      ];

      Promise.all(promises)
        .then(() => resolve(true))
        .catch((error: Error) => reject(error));
    });
  }


  /**
   * Eliminar todos los datos locales
   *
   */
  destroyData() {
    this.filtersService.delete();

    this.localsService.model.delete();
    this.localsService.modelLocalFamilies.delete();
    this.locationsService.model.delete();
    this.rolesService.model.delete();
    this.devicesService.model.delete();
    this.usersService.model.delete();
    this.departmentsService.model.delete();
    this.servicesService.model.delete();
    this.allergensService.model.delete();
    this.unitsProductService.model.delete();
    this.vatService.model.delete();
    this.productsFamiliesService.model.delete();
    this.productsLabelsService.model.delete();
    this.notificationsService.model.delete();
    this.notificationsService.modelGroups.delete();
    this.notificationsService.modelConfig.delete();
    this.holidaysService.model.delete();
    this.holidaysService.modelTypes.delete();
    this.shiftsService.model.delete();
    this.familiesExpensesService.model.delete();
    this.contractsService.model.delete();
    this.contractsService.modelTypes.delete();
    this.contractsService.modelEndReasons.delete();
    this.categoriesService.model.delete();
    this.periodsService.model.delete();
    this.wastageService.model.delete();
    this.wastageService.modelTypes.delete();
    this.requestsService.model.delete();
    this.requestsService.modelTypes.delete();
    this.dashboardsService.model.delete();
    this.franchiseesService.model.delete();
    this.communicationsService.model.delete();
    this.communicationsService.breakdownsTypesModel.delete();
    this.communicationsService.breakdownsPrioritiesModel.delete();
    this.communicationsService.noticeFamiliesModel.delete();
    this.assistantService.model.delete();
    this.eventsService.model.delete();
    this.familiesEventsService.model.delete();
    this.clockInReportService.model.delete();
    this.purchasesReportsService.providerModel.delete();
    this.purchasesReportsService.productModel.delete();
    this.tasksReportsService.appccModel.delete();
    this.tasksReportsService.auditModel.delete();
    this.tasksReportsService.checklistsModel.delete();
    this.cashClosingService.model.delete();
    this.paymentsService.model.delete();
    this.paymentsService.modelTypes.delete();
    this.ebitdaService.model.delete();
    this.expensesService.model.delete();
    this.deliveryNotesService.model.delete();
    this.ordersService.model.delete();
    this.productsService.model.delete();
    this.productsService.suggestedProductsModel.delete();
    this.providersService.model.delete();
    this.providersService.purchaseFormatsModel.delete();
    this.clockInService.model.delete();
    this.foldersService.model.delete();
    this.publicHolidaysService.model.delete();
    this.schedulesService.model.delete();
    this.machinesCheckpointService.model.delete();
    this.productsCheckpointService.model.delete();
    this.providersCheckpointService.model.delete();
    this.schedulesAppccsService.model.delete();
    this.modelsService.model.delete();
    this.schedulesChecklistService.model.delete();
    this.imageReviewerService.model.delete();
    this.tasksService.model.delete();
    this.inventoriesService.model.delete();
    this.inventoryStockService.delete();
    this.reloadsService.model.delete();
    this.revisionsService.model.delete();
    this.operationsService.model.delete();
    this.stocksService.model.delete();
    this.transfersService.model.delete();
    this.elaborationsService.model.delete();
    this.labeledService.model.delete();
    this.miseEnPlaceService.model.delete();
    this.recipesService.model.delete();
    this.recipesCostingService.model.delete();
    this.documentsReviewService.model.delete();
  }

}
